import { render } from "./Navbar.vue?vue&type=template&id=466183ad&bindings={\"handleClick\":\"setup\",\"user\":\"setup\"}"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script